module.exports = __webpack_public_path__ + "static/media/PrincessSofia-Regular.f7e33739.ttf";